import http from '@/utils/http';
// 添加菜单
export const addMenu: (data: any) => Promise<any> = (data: any) => {
  return http({
    url: '/api/v2/dashboard/menu/addMenu',
    method: 'post',
    errorHandler: true,
    rawData: true,
    data: data,
  });
};

// 更新菜单
export const updateMenu: (data: any) => Promise<any> = (data: any) => {
  return http({
    url: '/api/v2/dashboard/menu/updateMenu',
    method: 'post',
    errorHandler: true,
    rawData: true,
    data: data,
  });
};

// 删除
export const delMenu: (data: any) => Promise<any> = (data: any) => {
  return http({
    url: '/api/v2/dashboard/menu/deleteMenu',
    method: 'post',
    data: data,
  });
};

// 移动菜单
export const moveMenu: (data: any) => Promise<any> = (data: any) => {
  return http({
    url: '/api/v2/dashboard/menu/updateMoveMenu',
    method: 'post',
    data: data,
  });
};

// 添加到收藏
export const deleteFromFavorite: (data: any) => Promise<any> = (data: any) => {
  return http({
    url: '/api/v1/dashboard/menu/deleteFavoritesMenu',
    method: 'post',
    data: data,
  });
};

// 删除收藏
export const addToFavorite: (data: any) => Promise<any> = (data: any) => {
  return http({
    url: '/api/v1/dashboard/menu/favoritesMenu',
    method: 'post',
    data: data,
  });
};

// 调整排序
export const updateMenuSort: (data: any) => Promise<any> = (data: any) => {
  return http({
    // url: 'api/v1/dashboard/menu/updateThirdMenu',
    url: '/api/v2/dashboard/menu/sortMenu',
    method: 'post',
    data: data,
  });
};

// 获取user level
export const getListUserLevel: (data: any) => Promise<any> = (data: any) => {
  return http({
    url: '/api/v1/dashboard/menu/listUserLevel',
    method: 'post',
    data: data,
  });
};

// 获取 tableau 列表
export const getTableauList: (data: any) => Promise<any> = (data: any) => {
  return http({
    url: '/api/v1/dashboard/tableauList',
    method: 'post',
    data: data,
  });
};

// 路径菜单是否存在
export const getPathValidity: (data: any) => Promise<any> = (data: any) => {
  return http({
    url: '/api/v1/dashboard/page_permission',
    method: 'post',
    data: data,
  });
};
